@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../global-styles/index.scss';

.ciProducts {
  display: flex;
  padding: 24px $spacing-16 $spacing-16 $spacing-16;
  align-items: flex-start;
  height: 334px;

  &-column {
    display: flex;
    flex-direction: column;
    flex: 1 0 0;

    &-list {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin: 0;
      margin-block: 0;
      padding-inline: 0;
      list-style-type: none;
      padding: 0 $spacing-8 $spacing-16 $spacing-8;
      line-height: 1.15rem;
    }
  }

  &-heading {
    color: $color-red-default !important;
    font-weight: 700;
  }

  &-new {
    display: flex;
    gap: 10px;
    padding: 0 $spacing-8;
    align-items: center;
  }

  &-inlineImage {
    width: 25px;
    display: inline-block;
    position: relative;
    padding: 0 0 0 3px;
    vertical-align: middle;
  }

  &-moreWaysToShop-icon {
    display: flex;
    gap: 5px;
    align-items: center;

    .ciProducts-inlineImage {
      width: 20px;
    }
  }
}
